/**
 * The vocabulary and onboarding every profile starts from.
 *
 * A leaf on purpose: `profiles.ts` folds over the module registry, and a
 * module's own profile needs these constants. Importing them from
 * `profiles.ts` would close a runtime cycle — registry → module → profile →
 * registry — which leaves `CORE_MODULES` undefined at import time.
 */
/**
 * Modules every profile gets: the invoicing spine, an accounting entry
 * point for each of the three regimes, and administration.
 *
 * `smt`, `funding` and `reporting` are listed here yet stay invisible to
 * most tenants — the regime axis shows `smt` only under SMT and the two
 * others only under SYCEBNL, so listing them widens nothing and keeps the
 * matching regime from losing its only door to those screens.
 *
 * The till (`pos`) and the inventory (`stock`) are deliberately absent: a
 * consulting firm sells neither over a counter nor out of a warehouse.
 * Each is a capability pack, and the profiles that need one declare it.
 * Every key listed here is `transversal-core` (module-classes.ts), which
 * a test asserts.
 */
export const CORE_MODULES = [
    "main", "dashboard",
    "ventes-caisse", "invoices", "verification",
    "clients-crm", "clients",
    "catalogue", "articles",
    "accounting", "smt", "fiscalite", "reports-hub",
    "funding", "reporting",
    "cabinet",
    "admin", "settings", "users", "roles",
];
/** Steps every tenant gets, in the order the API derives them. */
export const CORE_ONBOARDING = [
    { key: "profil-fiscal", optional: false },
    { key: "articles", optional: false },
    { key: "clients", optional: true },
    { key: "comptabilite", optional: true },
    { key: "mcf", optional: false },
    { key: "premiere-facture", optional: false },
];
//# sourceMappingURL=core-modules.js.map